/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.instance.edit.resources.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.templates',
  'acme.common.service.templates.helpers',
  'acme.common.service.validate',
  'acme.common.service.calendar',
  'acme.common.service.resources',
  'acme.common.service.permissions',
  'acme.common.service.userPreferences',
  'acme.common.service.themesHelper',
  'acme.common.factory.notice',
  'acme.common.factory.relink',
  'acme.view.application.programs.instance.edit.removeModal.controllers',
  'acme.view.application.programs.instance.edit.cancelModal.controllers',
  'acme.view.application.resources.modals.assign.controllers',
  'acme.view.application.resources.modals.request.controllers'
])

.controller('ProgramsInstanceEditResourcesController', ['$controller', '$scope', '$state', '$uibModal', '$timeout', '$filter', 'ApiService', 'ValidateService', 'HelpersService', 'CalendarService', 'TemplatesService', 'TemplatesHelpersService', 'NoticeFactory', 'RelinkFactory', 'GridStateFactory', 'UserPreferencesService', 'ResourcesService', 'PermissionsService', 'ThemesHelperService', function($controller, $scope, $state, $uibModal, $timeout, $filter, ApiService, ValidateService, HelpersService, CalendarService, TemplatesService, TemplatesHelpersService, NoticeFactory, RelinkFactory, GridStateFactory, UserPreferencesService, ResourcesService, PermissionsService, ThemesHelperService) {

    $scope.programsInstanceEditResources = {

      model: [],

      modalDialog: {},

      emailSetting: 'always',
      company: ThemesHelperService.getCompany(),

      schedule: {},
      isSubmitted: false,

      isLoaded: true,

      createPermissions: ['RESOURCES_REQUESTS_PERSON_CREATE', 'RESOURCES_REQUESTS_PLACE_CREATE', 'RESOURCES_REQUESTS_EQUIPMENT_CREATE'],

      notice: new NoticeFactory(),
      relink: new RelinkFactory(),
      gridState: new GridStateFactory(),

      grid: {
        pageSize: 50,
        rowHeight: 60,
        paginate: true,
        showFooter: true,
        enableRowSelection: false,
        multiselect: false,
        columns: [
          {
            field: 'timeSlot',
            displayName: 'Time',
            width: 140,
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.timeSlot }}</div>'
          },
          {
            field: 'eventScheduleDisplayName',
            displayName: 'Event - Schedule',
            cellTemplate: '<div class="ui-grid-cell-contents">{{ row.entity.eventScheduleDisplayName }}</div>'
          },
          {
            field: 'resourceTemplateName',
            displayName: 'Request For',
            onCellNavClick: function(row, col) {
              $scope.appScopeProvider.onResourceTemplateClick(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onResourceTemplateClick(row.entity)">{{ row.entity.requestFor }}</a></div>'
          },
          {
            field: 'resourceName',
            displayName: 'Assigned To',
            onCellNavClick: function(row, col) {
              $scope.appScopeProvider.assign(row.entity);
            },
            cellTemplate: '<div class="ui-grid-cell-contents">' +
                            '<a role="button" data-ng-click="grid.appScope.assign(row.entity)" data-ng-show="row.entity.resourceId">{{ row.entity.resourceName }}</a>' +
                            '<div class="text-center">' +
                              '<a role="button" class="btn btn-info btn-sm resources-requests-grid-btn" data-ng-click="grid.appScope.assign(row.entity)" data-ng-show="!row.entity.resourceId">{{ row.entity.assignLabel }}</a>' +
                            '</div>' +
                          '</div>'
          },
          {
            field: 'notes',
            displayName: 'Notes'
          }
        ]
      },

      init: function() {

        if (PermissionsService.check('RESOURCES_REQUESTS_UPDATE')) {
          this.grid.columns.unshift({
            field: 'action',
            displayName: 'Edit',
            onCellNavClick: function(row, col) {
              $scope.programsInstanceEditResources.update(row.entity.resourceCategory, row.entity);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents">' +
                            '<a data-ng-if="row.entity.resourceRequestType !== \'scheduleBased\'" data-ng-click="grid.appScope.update(row.entity.resourceCategory, row.entity)" role="link">Edit<span class="sr-only"> Resource</span></a>' +
                            '<a data-ng-if="row.entity.resourceRequestType === \'scheduleBased\'" data-ng-click="grid.appScope.update(row.entity.resourceCategory, row.entity)"><span class="fa fa-info-circle" title="To edit, go to the Schedule in the event template."></span><span data-permit="EVENT_TEMPLATE_UPDATE"> Edit</span></a>' +
                          '</div>',
            width: 60
          });
        }

        if (PermissionsService.check('RESOURCES_REQUESTS_DELETE')) {
          this.grid.columns.push({
            field: 'remove',
            displayName: 'Remove',
            width: 80,
            onCellNavClick: function(row, col) {
              $scope.programsInstanceEditResources.remove(row.entity);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents">' +
                            '<a data-ng-if="row.entity.resourceRequestType !== \'scheduleBased\'" data-ng-click="grid.appScope.remove(row.entity)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a>' +
                            '<a data-ng-if="row.entity.resourceRequestType === \'scheduleBased\'" data-ng-click="grid.appScope.remove(row.entity)" role="link"><span class="fa fa-info-circle" title="To remove, go to the Schedule in the event template."></span><span data-permit="[\'EVENT_TEMPLATE_UPDATE\', \'RESOURCES_REQUESTS_DELETE\']"> Remove</span></a>' +
            '</div>'
          });
        }

        if ($scope.programsInstance) {
          // Accessed from $scope.programsInstance intentionally
          this.schedule = $scope.programsInstance.model;
        }else if ($scope.programsInstanceEdit) {
          // Accessed from $scope.programsInstanceEdit intentionally
          this.schedule = $scope.programsInstanceEdit.model;
        }

        this.getNotificationPreference();
        this.getResourceRequests();
      },

      getNotificationPreference: function() {
        if (this.company.hasOwnProperty('notificationPreference')) {
          this.emailSetting = this.company.notificationPreference;
        }
      },

      getResourceRequests: function() {
        var props = $.extend({
          eventId: $state.params.id
        }, this.gridState.getGridState());

        ApiService.program.resources.requests.list(props).then(this.success.getResourceRequests, this.error.getResourceRequests);
      },

      findResourceRequest: function(id) {
        var i, ii, r = false;
        for (i = 0, ii = this.model.length; i < ii; i++) {
          if (this.model[i].id === id) {
            r = {
              index: i,
              item: this.model[i]
            };
            break;
          }
        }

        return r;
      },

      request: function(type, currentRequest, preset) {
        var self = $scope.programsInstanceEditResources;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/resources/modals/request/request.tpl.html',
          size: 'lg',
          controller: 'ResourcesModalsRequestController',
          resolve: {
            resourceCategory: function() {
              return type || 'personnel';
            },
            schedule: function() {
              return self.schedule;
            },
            templateId: function() {
              return self.eventTemplateId;
            },
            preset: function() {
              return preset || 'event';
            },
            request: function() {
              return currentRequest || {};
            },
            type: function() {
              return 'instance';
            },
            emailSetting: function() {
              return self.emailSetting;
            },
            showEmailNotification: function() {
              return true;
            }
          }
        });

        self.showModal.result.then(function (request) {
          var found;

          //update the request itself.
          if (request.id) {
            found = self.findRequest(request.id);

            if (found) {
              self.schedule.resourceRequests[found.index] = request;
            }else {
              if (!(self.schedule.resourceRequests instanceof Array)) {
                self.schedule.resourceRequests = [];
              }
              self.schedule.resourceRequests.push(request);
            }
          }else {
            if (!(self.schedule.resourceRequests instanceof Array)) {
              self.schedule.resourceRequests = [];
            }
            self.schedule.resourceRequests.push(request);
          }
          self.getResourceRequests();
        }, function () {
        });
      },

      assign: function(item) {
        var self = $scope.programsInstanceEditResources;

        if (PermissionsService.check(['RESOURCES_REQUESTS_ASSIGN', 'RESOURCES_REQUESTS_SELF_ASSIGN'])) {

          if (item.resourceCategory === 'Personnel' &&
            !PermissionsService.check('RESOURCES_REQUESTS_ASSIGN')) {
            // Self assign only permission
            if (!item.resourceId) {
              self.selfAssign(item);
            }else{
              self.showAssignModal(item);
            }
          }else if (PermissionsService.check('RESOURCES_REQUESTS_ASSIGN')) {
            self.showAssignModal(item);
          }else{
            $scope.$emit('Permissions::error');
          }
/*
          self.showModal = $uibModal.open({
            templateUrl: 'views/application/views/resources/modals/assign/assign.tpl.html',
            size: 'lg',
            controller: 'ResourcesModalsAssignController',
            resolve: {
              request: function () {
                return request;
              }
            }
          });

          self.showModal.result.then(function (request) {
            var found;
            request = self.processResourceRequests([request])[0];

            if (request.id) {
              found = self.findResourceRequest(request.id);

              if (found) {
                self.model[found.index] = request;
              } else {
                self.model.push(request);
              }
            } else {
              self.model.push(request);
            }
          }, function () {
          });*/
        }else{
          $scope.$emit('Permissions::error');
        }
      },

      remove: function(item) {
        var self = $scope.programsInstanceEditResources;

        if (item && (item.resourceRequestType === 'scheduleBased')) {
          if (PermissionsService.check('EVENT_TEMPLATE_UPDATE') && PermissionsService.check('RESOURCES_REQUESTS_DELETE')) {
            $state.go('application.templates.edit.schedules.edit.resources', ({ id: self.schedule.templateId, scheduleId: self.schedule.scheduleId}));
          }
        } else if (PermissionsService.check('RESOURCES_REQUESTS_DELETE')) {
          self.showRemoveModal = $uibModal.open({
            templateUrl: 'views/application/views/resources/requests/modals/remove.tpl.html',
            size: 'md',
            controller: 'ResourcesRequestsRemoveModalController',
            resolve: {
              resourceRequest: function () {
                return {
                  resourceTemplateName: self.schedule.resourceTemplateName ? self.schedule.resourceTemplateName : item.resourceTemplateName,
                  eventName: self.schedule.name,
                  request: item
                };
              },
              emailSetting: function () {
                return self.emailSetting;
              },
              showEmailNotification: function() {
                return true;
              }
            }
          });

          self.showRemoveModal.result.then(function (notificationEmail) {
              var self = $scope.programsInstanceEditResources,
                found = self.findResourceRequest(item.id),
                props = item;
              if (found) {
                self.model.splice(found.index, 1);
                found = self.findRequest(item.eventInstanceResourceRequestId);
                if (found) {
                  self.schedule.resourceRequests.splice(found.index);
                }
              }
              ApiService.program.resources.instance.remove({
                id: props.eventId,
                requestId: props.eventInstanceResourceRequestId,
                sendEmail: notificationEmail
              }).then(self.success.remove, self.error.remove);
            },
            function () {
              //do nothing;
            });
        }
      },

      selfAssign: function(request) {
        // Instantiate controller with new $scope
        var ResourcesModalsAssignViewModel = $scope.$new(),
          ResourcesModalsAssignController = $controller('ResourcesModalsAssignController', {
            $scope : ResourcesModalsAssignViewModel,
            $uibModalInstance: {
              close: function(request) {
                $scope.programsInstanceEditResources.completeAssign(request);
              },
              dismiss: function() {}
            },
            request: request,
            emailSetting: $scope.programsInstanceEditResources.emailSetting
          });

        ResourcesModalsAssignViewModel.resourcesModalsAssign.assignToSelf();
        // Destroy the scope and thereby the controller as well
        ResourcesModalsAssignViewModel.$destroy();
      },

      showAssignModal: function(request) {
        var self = $scope.programsInstanceEditResources;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/resources/modals/assign/assign.tpl.html',
          size: 'lg',
          controller: 'ResourcesModalsAssignController',
          resolve: {
            request: function () {
              return request;
            },
            emailSetting: function () {
              return self.emailSetting;
            }
          }
        });

        self.showModal.result.then(function (request) {
          self.completeAssign(request);
        }, function () {
        });
      },

      update: function(category, currentRequest) {
        var self = $scope.programsInstanceEditResources,
            found;
        if (currentRequest && (currentRequest.resourceRequestType === 'scheduleBased')) {
          if (PermissionsService.check('EVENT_TEMPLATE_UPDATE')) {
            $state.go('application.templates.edit.schedules.edit.resources', ({ id: self.schedule.templateId, scheduleId: self.schedule.scheduleId}));
          }
        } else {
          if (PermissionsService.check('RESOURCES_REQUESTS_UPDATE') && currentRequest.eventInstanceResourceRequestId) {
            found = self.findRequest(currentRequest.eventInstanceResourceRequestId);
            if (found) {
              if (currentRequest.resourceId && currentRequest.resourceName) {
                found.request.eventResource.resourceId = currentRequest.resourceId;
                found.request.eventResource.resourceName = currentRequest.resourceName;
              }
              self.request(category, found.request, 'event');
            }
          }
        }
      },

      findRequest: function(id) {

        var i, ii,
          r = false,
          list = this.schedule.resourceRequests instanceof Array ? this.schedule.resourceRequests : [];

        if (id) {
          for (i = 0, ii = list.length; i < ii; i++) {
            if (list[i].id === id) {
              r = {
                index: i,
                request: list[i]
              };
              break;
            }
          }
        }

        return r;

      },

      gridDoubleClick: function(row) {
        $scope.programsInstanceEditResources.update(row.entity.resourceCategory, row.entity);
      },

      onResourceTemplateClick: function(item) {
        $state.go('application.entities.templates.edit', { type: item.resourceCategory.toLowerCase(), id: item.resourceTemplateId });
      },

      processResourceRequests: function(requests) {
        var i, ii, startTime, endTime;
        for (i = 0, ii = requests.length; i < ii; i++) {
          startTime = CalendarService.parseDate(requests[i].resourceStartTime);
          endTime = CalendarService.parseDate(requests[i].resourceEndTime);
          requests[i].timeSlot =  this.getDateRange(startTime, endTime);
          requests[i].eventScheduleDisplayName = requests[i].eventName + ( requests[i].eventScheduleName ? (' - ' + requests[i].eventScheduleName) : '');
          requests[i].assignLabel = 'Assign';

          if (requests[i].resourceCategory === 'Personnel' &&
            !PermissionsService.check(['RESOURCES_REQUESTS_ASSIGN']) &&
            PermissionsService.check(['RESOURCES_REQUESTS_SELF_ASSIGN'])) {
            requests[i].assignLabel = 'Assign to me';
          }

          if (!(requests[i].values instanceof Array) || !requests[i].values.length) {
            requests[i].requestFor = requests[i].resourceTemplateName;
          }else if (requests[i].values.length < 3) {
            requests[i].requestFor = requests[i].resourceTemplateName + ': ' + requests[i].values.join(', ');
          }else{
            requests[i].requestFor = requests[i].resourceTemplateName + ': ' + requests[i].values.slice(0, 3).join(', ') + ', ' + '+ more';
          }

        }

        return requests;
      },

      getDateRange: function(start, end) {
        var r = $filter('date')(CalendarService.parseDate(start), UserPreferencesService.getDateTimeFormat('shortDateTime'));

        if (end) {
          r += ' - ';
          r += $filter('date')(CalendarService.parseDate(end), UserPreferencesService.getDateTimeFormat('shortDateTime'));
        }else{
          r += ' - Indefinite';
        }

        return r;
      },

      completeAssign: function(request) {
        var found;

        request = this.processResourceRequests([request])[0];

        if (request && request.id) {
          found = this.findResourceRequest(request.id);

          if (found) {
            this.model[found.index] = request;
          } else {
            this.model.push(request);
          }
        } else {
          this.model.push(request);
        }

      },

      success: {
        getResourceRequests: function(response) {
          var self = $scope.programsInstanceEditResources;
          self.model = self.processResourceRequests(response.data.payload.list);
          self.isLoaded = true;
        }
      },

      error: {
        getResourceRequests: function(response) {
          var self = $scope.programsInstanceEditResources;

          self.isLoaded = true;
        },
        getResourceRequest: function(response) {

        }
      }

    };

    $scope.programsInstanceEditResourcesGrid = {
      enableRowSelection: false,
      paginate: false,
      showFooter: false,
      multiSelect: false
    };


    $scope.programsInstanceEditResources.init();

    $scope.appScopeProvider = {
      assign: $scope.programsInstanceEditResources.assign,
      remove: $scope.programsInstanceEditResources.remove,
      update: $scope.programsInstanceEditResources.update,
      onGridDblClick: $scope.programsInstanceEditResources.gridDoubleClick,
      onResourceTemplateClick: $scope.programsInstanceEditResources.onResourceTemplateClick
    };

}])

;
